import { render, staticRenderFns } from "./mascaraMoeda.vue?vue&type=template&id=524d0aec"
import script from "./mascaraMoeda.vue?vue&type=script&lang=js"
export * from "./mascaraMoeda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports